import React from "react";
import { ArrowLeft, ArrowRight, ReplyFill } from "react-bootstrap-icons";

import { getTranslation } from "../../../../helpers/getLanguage";
import "./styles.css";

export const IdeaNavigationFooter = ({
  resetIdea,
  prevEnabled,
  nextEnabled,
  handleRightClick,
  handleLeftClick,
  disabledNextButton,
  undoResetIdea,
  checkedTab,
}) => {
  return (
    <div className="idea-dialog-buttons">
      <button
        className={"idea-nav-dialog-button secondary control" + (prevEnabled() ? "" : " hidden")}
        onClick={handleLeftClick}
      >
        <ArrowLeft className="dialog-buttons-arrow-left" />
        <span>{getTranslation("IDEA_MODAL_BUTTON_PREVIOUS")}</span>
      </button>

      <button
        className={
          "idea-nav-dialog-button dark-blue-btn control" +
          (nextEnabled() ? "" : " hidden") +
          (disabledNextButton ? " disabled" : "")
        }
        onClick={handleRightClick}
      >
        <span>{getTranslation("IDEA_MODAL_BUTTON_NEXT")}</span>

        <ArrowRight className="dialog-buttons-arrow-right" />
      </button>
      <div className="idea-dialog-footer-buttons">
        <button className="idea-clear-dialog-button" onClick={resetIdea}>
          {getTranslation("IDEA_MODAL_BUTTON_CLEAR")}
        </button>
        {checkedTab && (
          <button className="idea-undo-dialog-button" onClick={undoResetIdea}>
            <ReplyFill className="idea-undo-dialog-button-icon" />
          </button>
        )}
      </div>
    </div>
  );
};
